<template>
  <component
    :is="seoHeadingtype"
    v-if="title"
    class="content-title"
  >
    {{ title }}
  </component>
</template>

<script setup lang="ts">
  const props = defineProps<{
    headingType?: string
    title?: string
  }>()

  const options = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
  const seoHeadingtype = computed(() => (options.includes(props.headingType) ? props.headingType : 'h2'))
</script>
